import { FC } from 'react';

import Button from '@/components/elements/Button/BaseButton';
import { dayjst } from '@/lib/dayjst';
import { Campaign } from '@/lib/microcms/model';

import { EntryButtonArea } from './style';

interface FloatEntryButtonProps {
  isEntered: boolean;
  campaign: Campaign;
  onClick: () => void;
}

const FloatEntryButton: FC<FloatEntryButtonProps> = ({
  isEntered,
  campaign,
  onClick,
}) => {
  // キャンペーン期間外の場合は表示しない
  if (
    (!campaign.entryCampaignName && !campaign.entryCampaign) ||
    !dayjst().isBetween(campaign.startTime, campaign.endTime)
  ) {
    return <></>;
  }

  return (
    <EntryButtonArea isEntered={isEntered}>
      <Button
        size={['m', 'l']}
        bgColor="primary"
        fontWeight="bold"
        width={['300px', '320px']}
        height={['48px', '56px']}
        radius="l"
        disabled={isEntered}
        onClick={() => onClick()}
      >
        {isEntered ? 'エントリー済み' : 'エントリーする'}
      </Button>
    </EntryButtonArea>
  );
};

export default FloatEntryButton;
